import React from "react";
import { css } from "react-emotion";
import { Link } from "react-router-dom";
import appLogo from "assets/images/app_logo.svg";

const propTypes = {};

class Nav extends React.Component {
  render() {
    return (
      <nav className={styles.nav}>
        <div className="nav_main_logo">
          <Link to="/">
            <img src={appLogo} alt="" />
          </Link>
        </div>
      </nav>
    );
  }
}

Nav.propTypes = propTypes;
export default Nav;

const styles = {
  nav: css`
     {
      position: fixed;
      z-index: 3;
      height: 70px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #e91e63;
      padding: 0 0 0 2%;
      box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.05), 0px 10px 20px 5px rgba(0, 0, 0, 0.15),
        2px 10px 60px 1px rgba(0, 0, 0, 0.05);
    }
  `,
};



// WEBPACK FOOTER //
// ./src/pages/tutorial/Nav.jsx